module.exports = __webpack_public_path__ + "img/login-img.1d858ddf.png";